import { InjectionToken, makeStateKey, StateKey } from '@angular/core';

/**
 * Per-request bot verdict computed by the SSR server and supplied at the platform injector
 * (see provider-directory server.ts). Optional: it is absent on the browser and in the
 * CSR-fallback render paths that never run Angular on the server.
 */
export const SERVER_BOT_VERDICT = new InjectionToken<boolean | undefined>('ServerBotVerdict');

/**
 * TransferState key the server writes the verdict under so it serializes into the rendered
 * HTML and can be read once during browser hydration.
 */
export const SM_BOT_VERDICT_STATE_KEY: StateKey<boolean> = makeStateKey<boolean>('sm-bot-verdict');
